import React, { useMemo, useState } from "react";
import { Button, Col, Form, Input, Label, Row } from "reactstrap";
import ToastAlert from "../../Components/Common/ToastAlert";
import { APIClient } from "../../helpers/api_helper";

const NewComboModal = ({ isOpen, toggle, getInputList }) => {
    const api = useMemo(() => new APIClient(), []);

    const [location, setLocation] = useState("");
    const [country, setCountry] = useState("TR");
    const [keyword, setKeyword] = useState("");

    const handleModalClick = (e) => {
        if (e.target.classList.contains("modal")) {
            toggle();
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!location.trim()) {
            ToastAlert("Location cannot be empty.", "warning");
            return;
        }
        if (!keyword.trim()) {
            ToastAlert("Keyword cannot be empty.", "warning");
            return;
        }
        try {
            await api.update("v1/inputs/", {
                location: location.trim(),
                keyword: keyword.trim(),
                country: country.trim().toUpperCase(),
            });
            await getInputList();
            toggle();
            ToastAlert("Combination added successfully.", "success");
        } catch (error) {
            ToastAlert(error, "error");
        }
    };

    return (
        <React.Fragment>
            <div
                className={`modal fade ${isOpen ? "show" : ""}`}
                tabIndex="-1"
                role="dialog"
                style={{ display: isOpen ? "block" : "none" }}
                onClick={handleModalClick}
            >
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header border-bottom-0">
                            <h5 className="modal-title">Add New Combination</h5>
                            <button type="button" className="btn-close" onClick={toggle}></button>
                        </div>
                        <div className="modal-body">
                            <Form onSubmit={handleSubmit}>
                                <Row className="mb-3">
                                    <Col>
                                        <Label className="form-label">
                                            Location <span className="text-danger">(*)</span>
                                        </Label>
                                        <Input
                                            type="text"
                                            autoFocus
                                            className="form-control"
                                            value={location}
                                            onChange={e => setLocation(e.target.value)}
                                            placeholder="e.g. Izmir"
                                        />
                                    </Col>
                                    <Col xs="auto" style={{ minWidth: "100px" }}>
                                        <Label className="form-label">
                                            Country Code <span className="text-danger">(*)</span>
                                        </Label>
                                        <Input
                                            type="text"
                                            className="form-control"
                                            value={country}
                                            maxLength={2}
                                            onChange={e => setCountry(e.target.value.toUpperCase())}
                                            placeholder="TR"
                                        />
                                    </Col>
                                </Row>

                                <div className="mb-3">
                                    <Label className="form-label">
                                        Keyword <span className="text-danger">(*)</span>
                                    </Label>
                                    <Input
                                        type="text"
                                        className="form-control"
                                        value={keyword}
                                        onChange={e => setKeyword(e.target.value)}
                                        placeholder="e.g. Rust"
                                    />
                                </div>

                                <div className="hstack gap-2 justify-content-end">
                                    <Button type="button" className="btn btn-light" onClick={toggle}>
                                        Cancel
                                    </Button>
                                    <Button type="submit" className="btn btn-warning">
                                        Save
                                    </Button>
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
            {isOpen && <div className="modal-backdrop fade show"></div>}
        </React.Fragment>
    );
};

export default NewComboModal;
